import api from '@/api';

const resource = 'ei/sincronizacao';

export default {
  postNota(data) {
    return api.post(`${resource}/nota`, data);
  },
  postFrequencia(data) {
    return api.post(`${resource}/frequencia`, data);
  },
  postConceito(data) {
    return api.post(`${resource}/conceito`, data);
  },
  postParecerDescritivo(data) {
    return api.post(`${resource}/parecer-descritivo`, data);
  },
};
